var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"savedLocationList"},_vm._l((_vm.locationItems),function({ id, address }){return _c('ListItemSavedLocation',{key:id,attrs:{"title":address},on:{"click":function($event){return _vm.selectLocation(id, address)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }